import {
  all,
  AllEffect,
  ForkEffect,
  StrictEffect,
  put,
  call,
  select,
  takeLatest,
} from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import BffApiService from '@/shared/bffApiService';

import {
  getHeaderBannersError,
  getHeaderBannersSuccess,
  HeaderBannersActionType,
} from '@/store/cms/header-banners/actions';
import { selectUserBtagPrefix } from '@/store/selectors/combined.selectors';
import { BffCmsHeaderBannersResponse, BffResponse } from '@lucky7ventures/bff-types';

export function* getHeaderBannersSaga(): Generator<
  StrictEffect,
  void,
  AxiosResponse<BffResponse<BffCmsHeaderBannersResponse>>
> {
  try {
    const btag = yield select(selectUserBtagPrefix);
    const response = yield call(BffApiService.getHeaderBanners, {
      config: { params: { btag } },
    });

    if (response.data.data) {
      yield put(getHeaderBannersSuccess(response.data.data));
    }
  } catch (error) {
    yield put(getHeaderBannersError());
  }
}

export function* watchHeaderBannersSagas(): Generator<AllEffect<ForkEffect<never>>, void> {
  yield all([takeLatest(HeaderBannersActionType.GetHeaderBanners, getHeaderBannersSaga)]);
}
